import React from "react"
import { Modal, Tag } from "antd"

const getTextToImageGenerations = (detail) => {
  if (!detail) return []

  const payload = detail.result ?? detail.data?.result ?? detail

  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.list)) return payload.list
  if (Array.isArray(detail.list)) return detail.list
  if (payload?.output || payload?.user_prompt || payload?.status) return [payload]

  return []
}

const TextToImgModal = ({ open, onClose, data, onImageClick }) => {
  const lang = localStorage.getItem("language") || "ar"
  const generations = getTextToImageGenerations(data?.detail)
  const hasData = generations.length > 0
  const firstGen = generations[0]
  const timestamp = firstGen
    ? [firstGen.date, firstGen.time].filter(Boolean).join(" ")
    : "—"

  return (
    <Modal
      title={
        <div>
          <div className="d-flex">
            <div
              className={
                lang === "ar" ? "r-r-modal-icon-arabic" : "r-r-modal-icon"
              }
            >
              <img src="/dashboard/room-redesign-v2.svg" alt="" />
            </div>
            <div>
              <div className="modal-heading" style={{ marginBottom: 0 }}>
                {lang === "ar" ? "تحويل النص إلى صورة" : "Text to Image"}
              </div>
              <p className="modal-timestamp">{timestamp}</p>
            </div>
          </div>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "75vh",
        padding: "0 12px",
      }}
    >
      <div style={{ flex: "0 0 auto", paddingTop: 16 }}>
        <p
          style={{
            fontStyle: "italic",
            marginBottom: 12,
            color: "#555",
          }}
        >
          {lang === "ar"
            ? "تم إنشاء صورة بالذكاء الاصطناعي من نص الإدخال"
            : "Generated AI image from text prompt"}
        </p>

        <div className="generation_thread">
          {lang === "ar" ? "سلسلة التوليد" : "Generation Thread"}
        </div>
      </div>

      <div
        className="scrollable-cards"
        style={{
          flex: "1 1 auto",
          overflowY: "auto",
          marginTop: "10px",
        }}
      >
        {hasData ? (
          generations.map((gen, index) => {
            const status = String(gen?.status ?? "").toLowerCase()
            const isSuccess = status === "success"
            const isFailed = status === "failed" || status === "error"
            const genTimestamp = [gen.date, gen.time].filter(Boolean).join(" ")

            return (
              <div className="text-to-img" key={`${gen.output || index}-${index}`}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <span>
                    <span className="count-container">
                      {String(index + 1).padStart(2, "0")}
                    </span>{" "}
                    <span className="modal-div-date">&nbsp; {genTimestamp}</span>
                  </span>
                  {isSuccess ? (
                    <Tag color="green">
                      {lang === "ar" ? "ناجح" : "Success"}
                    </Tag>
                  ) : (
                    <Tag color="red">{lang === "ar" ? "فشل" : "Failed"}</Tag>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      border: "1px solid #eee",
                      borderRadius: "10px",
                      padding: "12px",
                      background: "#fafafa",
                      minWidth: "320px",
                    }}
                  >
                    <div className="modal-input-label">
                      {lang === "ar" ? "المدخل" : "Input"}
                    </div>
                    <div>
                      <div>
                        {lang === "ar" ? "نص المستخدم" : "User prompt"}
                      </div>
                      <p
                        style={{
                          border: "1px solid #ddd",
                          padding: "12px",
                          borderRadius: "4px",
                          marginTop: "5px",
                        }}
                      >
                        {gen.user_prompt}
                      </p>
                      <div
                        style={{ paddingTop: "20px" }}
                        className="modal-input-label"
                      >
                        {lang === "ar" ? "النص المترجم" : "Translated prompt"}
                      </div>
                      <p
                        style={{
                          border: "1px solid #ddd",
                          padding: "12px",
                          borderRadius: "4px",
                          minHeight: "45px",
                        }}
                      >
                        {gen.translated_prompt || ""}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      flex: 1,
                      border: "1px solid #eee",
                      borderRadius: "10px",
                      padding: "12px",
                      background: isFailed
                        ? "#fff5f5"
                        : "rgba(250,250,250,0.9)",
                      minWidth: "280px",
                    }}
                  >
                    {isFailed ? (
                      <div
                        style={{
                          color: "#d93025",
                          border: "1px solid #f5c2c2",
                          borderRadius: "8px",
                          padding: "10px",
                          fontWeight: 500,
                        }}
                      >
                        {lang === "ar" ? "السبب:" : "Reason:"}
                        <br />
                        <span style={{ color: "red" }}>
                          {gen.reason ||
                            (lang === "ar"
                              ? "لم يتم توفير سبب"
                              : "No reason provided")}
                        </span>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#404040",
                            paddingBottom: "10px",
                          }}
                        >
                          {lang === "ar" ? "الناتج" : "Output"}
                        </div>
                        <img
                          src={gen.output}
                          alt="output"
                          referrerPolicy="no-referrer"
                          onClick={() => {
                            if (onImageClick && gen.output) {
                              onImageClick(
                                gen.output,
                                lang === "ar"
                                  ? "تحويل النص إلى صورة"
                                  : "Text to Image",
                              )
                            }
                          }}
                          style={{
                            width: "100%",
                            maxWidth: "200px",
                            borderRadius: "8px",
                            cursor: onImageClick ? "pointer" : "default",
                            transition: "opacity 0.2s",
                          }}
                          onMouseEnter={(e) => {
                            if (onImageClick) {
                              e.currentTarget.style.opacity = "0.8"
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (onImageClick) {
                              e.currentTarget.style.opacity = "1"
                            }
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            )
          })
        ) : (
          <p style={{ color: "#888", fontSize: "14px", textAlign: "center" }}>
            {lang === "ar" ? "لا توجد بيانات توليد" : "No generation data"}
          </p>
        )}
      </div>
    </Modal>
  )
}

export default TextToImgModal
